import React from 'react';
import { Chip } from '@mui/material';

// GameType enum values matching backend: 0=Regular, 1=Playoff, 2=Friendly, 3=SemiFinal, 4=Final, 5=Bye
const GAME_TYPE_CONFIG = {
  0: { label: 'League', color: 'success' },
  1: { label: 'Playoff', color: 'secondary' },
  2: { label: 'Friendly', color: 'info' },
  3: { label: 'Semi-Final', color: 'warning' },
  4: { label: 'Final', color: 'error' },
  5: { label: 'BYE', color: 'default' },
};

export const GAME_TYPE_LABELS = {
  0: 'League',
  1: 'Playoff',
  2: 'Friendly',
  3: 'Semi-Final',
  4: 'Final',
  5: 'BYE',
};

const GameTypeBadge = ({ gameType, size = 'small' }) => {
  const config = GAME_TYPE_CONFIG[gameType];
  if (!config || !config.label) return null;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      variant="outlined"
      clickable={false}
      onClick={() => {}}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default GameTypeBadge;
